import React from 'react';

const SmallProject = ({ id, title, para, link, linkRef }) => {
  return (
    <div className="additional-project" id={id}>
      <div className="card-shader"></div>
      <div className="title-box">{title}</div>
      <p>{para}</p>
      <a className="link underline italic" href={linkRef}>
        {link}
      </a>
    </div>
  );
};

export default SmallProject;
